import React from 'react';
import { connect } from 'react-redux';
import {
    userActions,
    userService,
    PasswordInputs,
    alertActions,
    SupportContactArea,
} from '../../../components';
import { utilService, history } from '../../../_helpers';
import './UserLoginPage.scss';
import localStorage from 'local-storage';
import withNoAuthNav from '../../_shared/Nav/withNoAuthNav';

const initialValidationState = {
    password: {
        validated: true,
        message: '',
    },
    confirmPassword: {
        validated: true,
        message: '',
    },
};
class UserResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            validations: initialValidationState,
            submitted: false,
            user: {},
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    async componentDidMount() {
        document.title = 'Brandshare Collaboration - Reset Password';
        this.props.dispatch(userActions.logout());

        var code = utilService.getQueryStringValue(
            'code',
            window.location.search,
            window.location.href,
        );

        
        var response = await userService.validatePasswordReset(code);
        var { user } = response;

        // 2 = invalid code
        // 3 = Expired
        switch (response.resultType) {
            case 1:
                {
                    user.inviteCode = code;
                    await utilService.setStateAsync.bind(this)({ user });
                }
                break;
            case 2:
                {
                    history.replace({
                        pathname: `/login`,
                        data: { redirectMessage: 'Link invalid' },
                    });
                }
                break;
            case 3:
                {
                    history.replace({
                        pathname: `/login`,
                        data: { redirectMessage: 'Link expired' },
                    });
                }
                break;
            default:
                {
                    history.replace({
                        pathname: `/login`,
                    });
                }
                break;
        }
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value, submitted: false });
    }

    async validateFields() {
        var globalValidation = true;
        var { validations } = this.state;
        var validationCopy = { ...validations };

        if (
            !this.state.password ||
            (this.state.password && userService.validatePassword(this.state.password))
        ) {
            validationCopy.password = {
                validated: false,
                message: "Password complexity didn't match ",
            };
            globalValidation = false;
        }
        if (
            !this.state.confirmPassword ||
            (this.state.confirmPassword && this.state.password !== this.state.confirmPassword)
        ) {
            validationCopy.confirmPassword = {
                validated: false,
                message: "Password didn't match ",
            };
            globalValidation = false;
        }
        await utilService.setStateAsync.bind(this)({
            validations: validationCopy,
        });
        return globalValidation;
    }

    async handleSubmit(e) {
        e.preventDefault();
        await utilService.setStateAsync.bind(this)({
            submitted: true,
            validations: initialValidationState,
        });
        var allValidated = await this.validateFields();
        if (!allValidated) {
            return;
        }
        const { password, confirmPassword, user } = this.state;
        if (password && confirmPassword && user) {
            var requestData = {
                id: user.id,
                password: password,
                inviteCode: user.inviteCode,
            };
            await userService.resetPassword(requestData);
            this.props.dispatch(alertActions.success('Done !'));
            history.push('/login');
        }
    }

    getImageSource() {
        var preference = localStorage.get('preference-theme') || 'light';        
        return preference === 'dark'?  '../../assets/Images/brand_logo_all_white.png' : '../../assets/Images/brand_logo.png';
    }

    render() {
        const { password, confirmPassword, submitted, validations, user } = this.state;
        return (
            <div className="mrnda-main-content padding-2x">
                <div className="mrnda-flex-center-wrapper">
                    <div className="sign-in-box-wrapper">
                        <div className="tenant-logo margin-2x--bottom typography--center">
                            <div>
                                {/* <i style={{ color: '#fc275c' }} className="fab fa-mix fa-7x"></i> */}
                                <img src={this.getImageSource()}></img>
                            </div>
                        </div>
                        <div className="sign-in-box mrnda-card padding-3x margin-4x--bottom">
                            <h1 className="margin-2x--bottom text--center">Reset password</h1>
                            <div className="tile-message">
                                <form className="" name="form" onSubmit={this.handleSubmit}>
                                    <div className="form-horizontal">
                                        <div className="form-horizontal">
                                            <p
                                                style={{
                                                    opacity: '.8',
                                                    fontSize: '12px',
                                                    textAlign: 'center',
                                                    width: '310px',
                                                    marginBottom: '10px',
                                                }}>
                                                for your account <br />
                                                <strong>{user.email}</strong>
                                            </p>
                                            <PasswordInputs
                                                submitted={submitted}
                                                passwordValue={password}
                                                confirmPasswordValue={confirmPassword}
                                                validations={validations}
                                                onChange={this.handleChange}
                                            />
                                            <div className="control-group">
                                                <div className="controls">
                                                    <button className="mrnda-btn mrnda-btn--full margin-2x--bottom">
                                                        Reset Password
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <p className="text sm-forward typography--center">
                                    <a className="typography--small" href=""></a>
                                </p>
                            </div>
                        </div>
                        <SupportContactArea />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

const connectedUserRegister = withNoAuthNav(connect(mapStateToProps)(UserResetPassword));
export { connectedUserRegister as UserResetPassword };
